import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent, Anchor as MantineAnchor } from '@mantine/core';
const _Anchor = forwardRef(({ ...props }, ref) => (_jsx(MantineAnchor, { ...props, ref: ref })));
_Anchor.displayName = 'Anchor';
export const Anchor = createPolymorphicComponent(_Anchor);
